
import { store, update } from '@/api/upgrades'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  @Prop() public model!: Record<string, any>

  rules = {
    question: [
      { required: true, message: '请输入问题', trigger: 'blur' }
    ],
    answer: [
      { required: true, message: '请输入回答', trigger: 'blur' }
    ]
  }

  loading = false

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    this.loading = true
    const params: Record<string, any> = this.model
    try {
      if (params.id) {
        await update(params.id, params)
      } else {
        await store(params)
      }
      this.$eva.success('Submit the success!')
      this.$router.push({ name: 'upgrades' })
    } finally {
      this.loading = false
    }
  }
}
